import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-speaker-off-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfSpeakerOffIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfSpeakerOffIcon(props: CcfSpeakerOffIconProps) {
  return (
    <SvgIcon
      {...props}
      width="26"
      height="23"
      viewBox="0 0 26 23"
      fill="none"
    >
      <path
        d="M12.3 11.142V18.798C12.3 19.262 12.3 19.498 11.836 19.727C11.4867 19.6693 11.163 19.5076 10.907 19.263L6.036 15.088C5.804 15.088 5.572 14.856 5.336 14.856H1.161C0.232 14.856 0 14.624 0 13.698V8.12402C0 7.42802 0.232 7.19802 0.929 7.19802H5.107C5.571 7.19802 5.807 6.96602 6.036 6.96602L10.911 2.78702C11.143 2.55502 11.375 2.32302 11.84 2.55502C12.305 2.78702 12.304 3.01902 12.304 3.48402C12.3013 6.03602 12.3 8.58869 12.3 11.142Z"
        fill="#6D6E70"

      />
      <path
        d="M17.411 8.357L22.982 2.557V2.089L21.125 0H20.657L14.857 6.036L17.411 8.357Z"
        fill="#6D6E70"
      />
      <path
        d="M17.411 13.929L22.982 19.729V19.961L21.125 22.05H20.657L14.857 16.25L17.411 13.929Z"
        fill="#6D6E70"
      />
      <path
        d="M17.643 12.768H25.768L26 12.536V9.51801L25.768 9.28601H17.643V12.768Z"
        fill="#6D6E70"
      />
    </SvgIcon>
  );
}

export default CcfSpeakerOffIcon;
